"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonToolbar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const clsx_1 = __importDefault(require("clsx"));
const styles_1 = require("./styles");
const ButtonToolbar = ({ children = [], ...props }) => {
    const classes = (0, styles_1.useStyles)();
    const { className, justifyContent = "flex-end" } = props;
    return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, justifyContent: justifyContent, className: className, children: react_1.Children.map(children, (button) => (0, react_1.cloneElement)(button, {
            className: (0, clsx_1.default)(classes[justifyContent], button.props.className),
        })) }));
};
exports.ButtonToolbar = ButtonToolbar;
//# sourceMappingURL=index.js.map